import { Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Fragment } from "react";
import { NumberField } from "../../../../../components/NumberField";

function InsuranceCoveragesPreview({ items }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierPhysicalRiskQuestionnaire"
  });

  return (
    <Grid templateColumns={"repeat(3, 1fr)"} gap={2}>
      <GridItem>
        <Heading marginBlock="1" align="left" size="xs">
          {t("inputs.insuranceType")}
        </Heading>
      </GridItem>
      <GridItem>
        <Heading marginBlock="1" align="left" size="xs">
          {t("inputs.coverageUSD")}
        </Heading>
      </GridItem>
      <GridItem>
        <Heading marginBlock="1" align="left" size="xs">
          {t("inputs.insuranceCompany")}
        </Heading>
      </GridItem>
      {items.map(item => {
        return <Fragment key={item.id}>
          <GridItem>
            <Text
              fontSize="sm"
              whiteSpace="break-spaces"
            >
              {item.insuranceType && item.insuranceType !== "" ? t(`insuranceTypeOptions.${item.insuranceType}`) : ""}
            </Text>
          </GridItem>
          <GridItem>
            {item.coverage !== null ?
              <NumberField textAlign={"left"} fontSize="sm" value={item.coverage} /> :
              <Text
                fontSize="sm"
                whiteSpace="break-spaces"
              >{""}
              </Text>
            }
          </GridItem>
          <GridItem>
            <Text
              fontSize="sm"
              whiteSpace="break-spaces"
            >
              {item.insuranceCompany && item.insuranceCompany !== "" ? item.insuranceCompany : ""}
            </Text>
          </GridItem>
        </Fragment>;
      })}
    </Grid>
  );
}

export default InsuranceCoveragesPreview;